import axios from "axios";
import React, { useEffect, useState } from "react";
import { api_key } from "../../api/Api";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";

const base_URL = "https://image.tmdb.org/t/p/original";

const Row = ({ title, fetchUrl, isLargeRow }) => {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);

  const [trailerUrl, setTrailerUrl] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${api_key.react_api_Url}${fetchUrl}`);
        setMovies(response.data.results);

        setLoading(false);
        // return response;
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const handleClick = (movie) => {
    if (trailerUrl) {
      setTrailerUrl("");
    } else {
      movieTrailer(movie.name || movie.title || movie.original_title || "")
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          setTrailerUrl(urlParams.get("v"));
        })
        .catch((error) => console.log(error));
    }
  };

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
    },
  };

  return (
    <div className='dashboard-container'>
      <div>
        <h3 className='title'>{title}</h3>
        <div className='movie-container'>
          {loading && <h1>loading...</h1>}
          {!loading &&
            movies.slice(0, 18).map((movie) => (
              <div key={movie.id} className='box-1'>
                <img
                  onClick={() => handleClick(movie)}
                  src={`${base_URL}${
                    isLargeRow ? movie.poster_path : movie.backdrop_path
                  }`}
                  alt='movie.name'
                />
              </div>
            ))}
        </div>
        {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
      </div>
    </div>
  );
};

export default Row;
